export default __webpack_public_path__ + "static/media/s2_female.36a24d1a.wav";